import styled, { css } from 'styled-components'
import { LoadingDotsProps } from './types'

export const LoadingContainer = styled.div<LoadingDotsProps>`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ verticalPadding }) =>
    verticalPadding &&
    css`
      padding: ${verticalPadding}px 0;
    `}
`

/**
 * [1]: Review once SASS file has been purged from the lands
 */
export const LoadingText = styled.p`
  &&& {
    /* [1] */
    color: ${(props) => props.theme.colors.greyDark};
    margin-top: ${(props) => props.theme.spacing.sm};
  }
`
